import React, { useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import Sidebar from './components/Sidebar';
import Header from './components/Header';
import Dashboard from './components/Dashboard';
import Courses from './components/Courses';
import CourseEdit from './components/CourseEdit';
import Quiz from './components/Quiz';
import SetQuiz from './components/SetQuiz';
import Analytics from './components/Analytics';
import UserManagement from './components/UserManagement';
import HealthWorkerDetail from './components/HealthWorkerDetail';
import AdminDetail from './components/AdminDetail';
import Content from './components/Content';
import Settings from './components/Settings';
import RoleManagerPage from './components/RoleManagerPage';
import CreateCourse from './components/createcourse';
import Feedback from './components/feedback';
import LoginPage from './components/login';
import { AuthProvider, useAuth } from './components/authcontext';
import ViewCourses from './components/ViewCourses';
import ViewQuiz from './components/ViewQuiz';
import Forum from './components/forum';
import Monitor from './components/Monitor';
import CertificateReview from './components/CertificateReview';
import BlogManager from './components/BlogManager';
import CertificateVerification from './components/CertificateVerification';
import AskVik from './components/AskVik';
import RoleBasedRoute from './components/RoleBasedRoute';
import AccessDenied from './components/AccessDenied';
import { routeAccess } from './utils/rbac';

const withAccess = (element, access = {}) => (
  <RoleBasedRoute {...access}>{element}</RoleBasedRoute>
);

function AppShell() {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const { isAuthenticated } = useAuth();

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <Routes>
      <Route path="/certificate/:courseId/:userId" element={<CertificateVerification />} />
      <Route
        path="/login"
        element={isAuthenticated ? <Navigate to="/dashboard" replace /> : <LoginPage />}
      />

      <Route
        path="/*"
        element={
          <RoleBasedRoute>
            <Sidebar isOpen={sidebarOpen} onToggle={toggleSidebar} />
            <div className={`main-content ${!sidebarOpen ? 'sidebar-closed' : ''}`}>
              <Header />
              <div className="main-content">
                <Routes>
                  <Route path="/" element={<Navigate to="/dashboard" replace />} />
                  <Route path="/dashboard" element={withAccess(<Dashboard />, routeAccess.dashboard)} />
                  <Route path="/courses" element={withAccess(<Courses />, routeAccess.courses)} />
                  <Route path="/courses/edit/:id" element={withAccess(<CourseEdit />, routeAccess.courseEdit)} />
                  <Route path="/quiz" element={withAccess(<Quiz />, routeAccess.quiz)} />
                  <Route path="/quiz/set" element={withAccess(<SetQuiz />, routeAccess.quizSet)} />
                  <Route path="/analytics" element={withAccess(<Analytics />, routeAccess.analytics)} />
                  <Route path="/user-management" element={withAccess(<UserManagement />, routeAccess.userManagement)} />
                  <Route path="/learners/:id" element={withAccess(<HealthWorkerDetail />, routeAccess.learnerDetail)} />
                  <Route path="/admins/:id" element={withAccess(<AdminDetail />, routeAccess.adminDetail)} />
                  <Route path="/content" element={withAccess(<Content />, routeAccess.content)} />
                  <Route path="/settings" element={withAccess(<Settings />, routeAccess.settings)} />
                  <Route path="/settings/roles" element={withAccess(<RoleManagerPage />, routeAccess.rolesManager)} />
                  <Route path="/createcourse" element={withAccess(<CreateCourse />, routeAccess.createCourse)} />
                  <Route path="/feedback" element={withAccess(<Feedback />, routeAccess.feedback)} />
                  <Route path="/courses/:id" element={withAccess(<ViewCourses />, routeAccess.courseView)} />
                  <Route path="/forum" element={withAccess(<Forum />, routeAccess.forum)} />
                  <Route path="/monitor" element={withAccess(<Monitor />, routeAccess.monitor)} />
                  <Route path="/certificates" element={withAccess(<CertificateReview />, routeAccess.certificates)} />
                  <Route path="/blog" element={withAccess(<BlogManager />, routeAccess.blog)} />
                  <Route path="/ask-vik" element={withAccess(<AskVik />, routeAccess.askVik)} />
                  <Route path="/quiz/:id" element={withAccess(<ViewQuiz />, routeAccess.quizView)} />
                  <Route path="/access-denied" element={withAccess(<AccessDenied />, routeAccess.accessDenied)} />
                  <Route path="*" element={<Navigate to="/dashboard" replace />} />
                </Routes>
              </div>
            </div>
          </RoleBasedRoute>
        }
      />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <div className="App">
        <AppShell />
      </div>
    </AuthProvider>
  );
}

export default App;
